var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCancelWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4225 3.57806C16.7229 3.87847 16.746 4.35116 16.4918 4.67807L16.4225 4.75657L11.1783 10.0005L16.4225 15.2447C16.7479 15.5702 16.7479 16.0978 16.4225 16.4232C16.1221 16.7236 15.6494 16.7468 15.3225 16.4926L15.244 16.4232L9.99981 11.179L4.75584 16.4232C4.4304 16.7487 3.90277 16.7487 3.57733 16.4232C3.27693 16.1228 3.25382 15.6501 3.50801 15.3232L3.57733 15.2447L8.82138 10.0005L3.57733 4.75657C3.25189 4.43114 3.25189 3.9035 3.57733 3.57806C3.87773 3.27766 4.35043 3.25455 4.67733 3.50874L4.75584 3.57806L9.99981 8.82211L15.244 3.57806C15.5694 3.25263 16.0971 3.25263 16.4225 3.57806Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancelWhite);
export default __webpack_public_path__ + "static/media/icon-cancel-white.782978c3f6c1e6668a5771d8bd468120.svg";
export { ForwardRef as ReactComponent };